import {InnerAvatar} from '../inner_avatar'

export const OpenShiftAvatar = props => <InnerAvatar baseColor="pink" colorSet="color-bordered-white" {...props} />
